import React, { useState, useRef, useContext,useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Modal } from "react-bootstrap";
// import { useNavigate } from 'react-router-dom';

import ConexContext from "../../context/ConexContext";




const ModalLogin = (props) => {

	// let navigate = useNavigate();
	// CONEX
	const {peticion} = useContext(ConexContext);
	const [searchParams] = useSearchParams();
	const [ModoURL, setModoURL] = useState(false);

	const [Error, setError] = useState("");

	const rUser = useRef();
	const rPsw = useRef();
	// const rEnt = useRef();
	useEffect(()=>{
		if (searchParams.has("FIRMA") && searchParams.has("ent"))
			setModoURL(true)
		else 
			setModoURL(false)
	},[searchParams,setModoURL])


	async function login() {
		setError('')
		if (rUser.current.value === '')
			setError('El usuario es necesario.')
		else if (rPsw.current.value === '')
			setError('La contraseña es necesaria.')
		// else if (rEnt.current.value === '')
		// 	setError('La entidad es necesaria.')
		else{
			// let res=await peticion(`/login`, {method:'POST',json:{user:rUser.current.value, psw:rPsw.current.value, cod_ent:rEnt.current.value}});
			let res=await peticion(`/login`, {method:'POST',json:{user:rUser.current.value, psw:rPsw.current.value}});
			if((res?.estado??true) || !res["res"]["auth"]) setError('Los datos introducidos son erróneos.');
			if(res?.mensaje==="El microservicio no responde") setError('Imposible la autentificación póngase en contacto con el administrador');
//			setToken(res["res"]["jwt"]);
			//navigate('/');//porque esto?
		}
	}

	return (
		<Modal
			show={true}
			animation={false}
			centered
			className='modalogin1'
		>
			<div id="modalcampos">
				<Modal.Body>
					<div className="contmodal fondoazul modales_campos col-xs-12 modalogin">

						<div className="col-xs-12">
							<div className="col-xs-12 centra">
								<div className="titular_modal">
									<h2>{ModoURL?'Inicio de sesión':'Iniciar sesión'}</h2>
									<i className="fa-solid fa-right-to-bracket"></i>
								</div>
							</div>
						</div>

						<div className="modal-body">
							<form >
								<div className="col-xs-12 form-group nopadding">
									<div className="col-xs-6">
										{!ModoURL &&
										<>
										<label htmlFor="inputUserName">Usuario <i className="fa-solid fa-user"></i></label>
										<input
											className="form-control"
											placeholder="Usuario"
											type="text"
											id="inputUserName"
											ref={rUser}
											onChange={() =>{setError('');props.setmensaje('')} }
											autoComplete="off"
										/>
										</>
										}

									</div>
								</div>
								<div className="col-xs-12 form-group nopadding">
									<div className="col-xs-6">
										{!ModoURL &&
										<>
										<label htmlFor="inputPassword">Contraseña <i className="fa-solid fa-lock"></i></label>
										<input
											className="form-control"
											placeholder="Contraseña"
											type="password"
											id="inputPassword"
											ref={rPsw}
											onChange={() =>{setError('');props.setmensaje('')}}
											autoComplete="off"
										/>
										</>
										}
									</div>
								</div>
								{/* <div className="col-xs-12 form-group nopadding">
									<div className="col-xs-6">
										<label htmlFor="inputEntidad">Entidad <i className="fa-solid fa-user"></i></label>
										<input
											className="form-control"
											placeholder="Entidad"
											type="text"
											id="inputEntidad"
											ref={rEnt}
											onChange={() => setError('')}
											autoComplete="off"
										/>

									</div>
								</div> */}
							</form>
						</div>
					</div>
					<Modal.Footer>
						{!ModoURL &&
						<button
							className="aplicar"
							onClick={() => {
								login();

							}}
						>
							Iniciar sesión
						</button>
					}
						<div className="col-xs-12 error">
							<p className="error1">{props.mensaje!==""?(props.mensaje):(Error) }</p>
						</div>

					</Modal.Footer>
				</Modal.Body>
			</div>
		</Modal>
	);
}

export default ModalLogin;